export const TAX_PERCENTAGe = 7.5;
